import React from 'react';

import { useOwner } from '../context/context.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';
import Tooltip from '../builder/Tooltip.js';

const ClassicPromoTag = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const is_multiparticipation = promotion?.multi_participation ?? false;
	const is_classic = (!is_multiparticipation) ? true : false;

	if(!is_classic) return null;

	return (
		<RibbonCollection
			_class={{ other:'gui_not_in_top_tiny' }}
			items={[{
				title:"Classic Promotion",
				color:'classic',
				_href:`${window.zendesk_base_url}13775587181076`,
				_target:'_blank',
				tooltip:<Tooltip with_icon={false} position='top'>Click to find out what the Classic Promotion tag means</Tooltip>,
			}]}
		/>
	)
}

export default ClassicPromoTag;